import React from 'react';
import { Panel, PanelHeader, PanelTitle } from '@prisjakt/ui/panel';
import { MiniCard } from '../mini-card';
import { MiniCardHorizontalScroll } from '../horizontal-scroll/variants/mini-card-horizontal-scroll';
import { ButtonSize } from '@prisjakt/ui/button';
import { useAppContext } from 'src/components/app-context';

type Category = {
  name: string;
  image: string;
  path: string;
};

type PopularCategoriesProps = {
  className?: string;
  categories: Category[];
  negativeMargin?: boolean;
};

export const PopularCategories: React.FC<PopularCategoriesProps> = props => {
  const { t } = useAppContext();
  return (
    <Panel className={props.className}>
      <PanelHeader>
        <PanelTitle>{t('landing', 'popular-categories.title')}</PanelTitle>
      </PanelHeader>
      <MiniCardHorizontalScroll
        negativeMargin={props.negativeMargin}
        buttonSize={ButtonSize.SMALL}
      >
        {props.categories.map(category => (
          <MiniCard
            key={category.name}
            title={category.name}
            image={category.image}
            to={category.path}
          />
        ))}
      </MiniCardHorizontalScroll>
    </Panel>
  );
};
